import { Observable, from } from 'rxjs'
import { map, catchError } from 'rxjs/operators'
import axios, { AxiosRequestConfig } from 'axios'
import config from '../../config'
import { InvitedUserData } from '../../types/web-api.types'

export class WebApi {
  private readonly axiosInstance = axios.create({
    baseURL: config.apiUrl || 'http://localhost:8000',
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Credentials': 'true',
    },
  })

  private request<T>(config: AxiosRequestConfig): Observable<T> {
    return from(this.axiosInstance.request<T>(config)).pipe(
      map((response) => response.data),
      catchError((error) => {
        // eslint-disable-next-line no-console
        console.error('API request failed:', error)
        throw error
      }),
    )
  }

  logout(): Observable<void> {
    return this.request<void>({
      method: 'GET',
      url: '/auth/logout?redirect=false',
    })
  }

  login(axiosConfig: AxiosRequestConfig): Observable<void> {
    return this.request<void>({
      baseURL: `${config.apiUrl}/auth` || 'http://localhost:8000/auth',
      ...axiosConfig,
    })
  }

  auth(axiosConfig: AxiosRequestConfig): Observable<void> {
    return this.request<void>({
      baseURL: `${config.apiUrl}/api` || 'http://localhost:8000/auth',
      ...axiosConfig,
    })
  }

  async getInvitedUserData(invitationId: string): Promise<InvitedUserData> {
    return await this.request<InvitedUserData>({
      method: 'GET',
      url: `/api/onboarding/info/${invitationId}`,
    }).toPromise()
  }
}
